export default __webpack_public_path__ + "static/media/seer.84b11d03.png";